import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import api from "../api/axios";

export default function Products() {
  const { user, loading, isQRSession } = useAuth();
  const navigate = useNavigate();
  const [products, setProducts]           = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [user, loading, navigate]);

  useEffect(() => {
    if (!user) return;
    api.get("/products")
      .then(({ data }) => setProducts(data))
      .catch(console.error)
      .finally(() => setLoadingProducts(false));
  }, [user]);

  if (loading || !user) return null;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-farm-green dark:text-green-400">
          Farm Products
        </h2>
        <div className="text-right">
          <div className="text-xs text-gray-500 dark:text-gray-400">Balance</div>
          <div className="text-lg font-bold text-farm-green dark:text-green-400">
            {user.balance?.toFixed(2)} credits
          </div>
        </div>
      </div>

      {user.balance < 4 && !isQRSession && (
        <div className="bg-amber-50 dark:bg-amber-900/30 border
                        border-amber-300 dark:border-amber-600 rounded-lg
                        p-3 text-sm text-amber-800 dark:text-amber-300">
          ⚠️ Your balance may be too low to place an order.{" "}
          <Link to="/add-credits" className="font-semibold hover:underline">
            Add credits here.
          </Link>
        </div>
      )}

      {loadingProducts ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin h-10 w-10 rounded-full border-4
                          border-farm-green border-t-transparent" />
        </div>
      ) : products.length === 0 ? (
        <p className="text-center text-gray-500 dark:text-gray-400 py-12">
          No products are available right now. Check back soon!
        </p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {products.map((p) => {
            const minPrice = Math.min(...p.variants.map((v) => v.price));
            return (
              <button
                key={p.id}
                onClick={() => navigate(`/products/${p.slug}`)}
                className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg
                           border border-farm-tan/30 dark:border-gray-700
                           p-6 text-left hover:border-farm-green
                           dark:hover:border-green-500 hover:shadow-xl
                           transition-all"
              >
                {p.imageUrl ? (
                  <img
                    src={p.imageUrl}
                    alt={p.name}
                    className="h-16 w-16 object-cover rounded-xl mb-3"
                  />
                ) : (
                  <div className="text-5xl mb-3">{p.emoji}</div>
                )}
                <div className="font-bold text-gray-800 dark:text-gray-100
                                text-lg">
                  {p.name}
                </div>
                {/* Short description on the card */}
                {p.shortDescription && (
                  <p className="text-sm text-gray-500 dark:text-gray-400
                                mt-1 mb-3 line-clamp-2">
                    {p.shortDescription}
                  </p>
                )}
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-farm-green dark:text-green-400
                                   font-bold text-sm">
                    From {minPrice} credits
                  </span>
                  <span className="text-xs text-farm-green dark:text-green-400
                                   font-semibold">
                    Order →
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
